<template>
    <edit-base-template 
            v-on:update='updateItem()'
            v-on:create='createItem()'
            v-on:cancel='cancelEdit()'
            v-on:delete='deleteItem()'
            :item='item' 
            :errors='errors' 
            :title='formTitle()'
            :candelete='true'>
        
        <template v-slot:body>
            <div class="form-group">
                <label for='name'>{{ $t('translations.name') }}</label>
                <input type='text' v-model='item.name' class='form-control' name="name">
            </div>

            <div class="form-group">
                <label for='icon'>{{ $t('translations.icon')}}</label>
                <!-- <input type='text' v-model='item.icon' class='form-control'> -->
                <br /><div class='icon-preview'><i v-if='item.icon' :class='"fa fa-2x fa-" + item.icon'></i></div>
                <autocomplete class='form-control'
                        ref='ac'
                        v-model='item.icon' 
                        source="/api/v1/icons?search="
                        results-property="data"
                        results-value="name"
                        @clear='item.icon = null'
                        :resultsDisplay='iconResultDisplay'
                        :request-headers="authHeaders"
                        @selected='setDisplayValue'
                        @close='setDisplayValue'>
                </autocomplete>
                
                <!-- v-on:change='updateFilterValue' -->
                        
            </div>

            <div class="form-group">
                <label for='name'>{{ $t('translations.colour')}}</label><br />
                <input type="color" v-model='item.colour'>
            </div>

            <!-- <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" :style="{'background-color': item.colour}" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Colour
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" :style="{'background-color': '#ff0000'}" href="#">Red</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                </div>
            </div> -->

            <div class="form-group" v-if='item.name'>
                <label for='name'>{{ $t('translations.preview') }}</label><br />
                <div class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': item.colour}">
                    <i v-if='item.icon' :class='"pr-1 fa fa-lg fa-" + item.icon'></i> {{ item.name }}
                </div>
            </div>

            

            <div class="form-group">
                <label for='use'>{{ $t('translations.use') }}</label>
                <div class="ml-4 form-check">
                    <input class="form-check-input" nmae="use1" id='use1' type='checkbox' :checked='item.tags_tag_use.find(obj => {return obj.tag_use_id == 1})' value='1' v-on:change='setUse($event, 1)'>
                    <label class="form-check-label" for='use1'>
                        {{tBrandKey("client") | capitalise}}
                    </label>
                </div>
                <div class="ml-4 form-check">
                    <input class="form-check-input" id='use2' type='checkbox' :checked='item.tags_tag_use.find(obj => {return obj.tag_use_id == 2})' value='2' v-on:change='setUse($event, 2)'>
                    <label class="form-check-label" for='use2'>
                        {{tBrandKey("request") | capitalise}}
                    </label>
                </div>
            </div>

        </template>

    </edit-base-template>
</template>

<script>
	export default {
        extends: app.base.editBase,
		props: [
		],
		data: function(){
			return {
                title: 'Tag',
                event: "tag",
                model: "tag",
                elementname: "Tag",
                route: '/api/v1/tags',
                item: {
                    name:"",
                    icon:"",
                    tags_tag_use: [],
                },
			};
		},
        
        computed: {
            icons() {
                return this.arrayToAutocomplete(this.$root.fontawesome);
                if(this.$refs.ac) {
                    if(this.$refs.ac.display.length < 2) {
                        return [];
                    }
                    
                    return this.arrayToAutocomplete(this.$root.fontawesome.filter(obj => {return obj.match(this.$refs.ac.display)}));
                }
                return [];
            },
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
        },
        methods: {
            getName() {
                return this.item.name;
            },
            resetItem() {
                this.item = {
                    name:"",
                    icon:"",
                    colour: "#1a72a0",
                    tags_tag_use: [],
                };
                this.errors = [];
                this.originalData = JSON.parse(JSON.stringify(this.item));
            },
            setUse(event, tag_use_id) {
                //console.info(event);
                var tags_tag_use_index = this.item.tags_tag_use.findIndex(obj => {return obj.tag_use_id == tag_use_id});
                if(tags_tag_use_index != -1 && !event.target.checked) {
                    this.item.tags_tag_use.splice(tags_tag_use_index, 1);
                }
                else if(event.target.checked) {
                    this.item.tags_tag_use.push({tag_use_id: tag_use_id});
                }
            },
            setDisplayValue() {
                Vue.nextTick(() => {this.$refs.ac.display = this.$refs.ac.value});
            },
            iconResultDisplay(item) {
                //console.info(item);
                return "<i class='fa fa-lg fa-" + item.name + "'></i><span class='ml-2'>" + item.name + "</span>";
            },
            
        }

    }
</script>
